<template>
  <Drawer v-bind="$attrs" container-padding-class="!px-4 !pt-4 pb-0">
    <template #content>
      <div class="flex md:flex-col flex-col content-wrapper">
        <slot />
      </div>
    </template>
  </Drawer>
</template>

<script setup lang="ts">
import { Drawer } from "prism";
import { usePanelHeight } from "@/composables/panel_height";
import { inject, Ref } from "vue";

const viewContainerRef = inject<Ref<HTMLElement>>("viewContainerRef");

const { getDrawerHeight } = usePanelHeight({ containerRef: viewContainerRef });

defineExpose({
  drawerHeight: getDrawerHeight("fullHeight"),
});
</script>

<style scoped>
.content-wrapper {
  width: 100%;
}
</style>
